import {TitleOfTheDocument} from "../../../../../model/personal-achievements/TitleOfTheDocument";
import {FileDto} from "../../../../../../../../common/dtos/FileDto";

export class AchievementFilteItem {
  event: string = '';
  document_number: string = '';
  title_of_the_document: TitleOfTheDocument = new TitleOfTheDocument();
  date_of_issue_of_document: Date = new Date();
  scan_copy_supporting_document: FileDto = new FileDto();
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-personal-achievements/achievement-files/achievement-file-add/achievement-filte-item.ts